<template>
  <div>
    <div class="collection-edit__item-inner">
      <div class="collection-edit__item-drag-trigger">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="collection-edit__item-img" v-if="image.public_path">
        <img :src="image.public_path" data-rjs="2">
      </div>

      <div class="collection-edit__item-btns">
        <button class="collection-edit__item-btn _purple _desc" @click="toggleExpandArea" :disabled="imageUploading">
          Title & description
        </button>
        <button class="collection-edit__item-btn _gray _image" :id="image.file_id + 'dropzone'"
                :action="replaceImageUrl" :disabled="imageUploading">
          <i class="fa fa-spinner fa-spin" v-if="imageUploading"></i> Replace Image
        </button>
        <button class="collection-edit__item-btn _transparent" :disabled="imageUploading"
                v-if="!isCover && image.public_path" @click="removeImage">Delete
          Image
        </button>
      </div>
    </div>

    <div class="collection-edit__item-desc">
      <div style="display:none" class="expand-area" :data-id="image.file_id">
        <div class="set-after">
          <label>Title</label>
          <input type="text" class="long-input" v-model="image.title">
        </div>

        <div class="set-after">
          <label>Description (optional)</label>
          <ck-editor name="description" :name="image.file_id + 'description'" v-model="image.description"></ck-editor>
        </div>

        <div class="checkboxes-wrap set-after">
          <h3>Subjects (max - 2)</h3>

          <label class="checkbox-label" v-for="artSubject in artSubjects">
            <input type="checkbox" :value="artSubject.id" v-model="image.art_subjects"> {{artSubject.name}}
          </label>
        </div>

        <div class="checkboxes-wrap set-after">
          <h3>Styles (max - 2)</h3>

          <label class="checkbox-label" v-for="style in styles">
            <input type="checkbox" :value="style.id" v-model="image.styles"> {{style.name}}
          </label>
        </div>

        <div class="set-after">
          <label>Keywords (separate each word with a comma)</label>
          <input type="text" class="long-input" v-model="image.keywords">
        </div>

        <div>
          <button class="collection-edit__btn _save" @click="editIllustration(image)"
                  style="padding: 0; border: 3px solid #6f1b57">Save Edits
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
    imageSet: {
      type: Object,
      required: true,
    },
    isCover: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    replaceImageUrl: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default() {
        return 'post';
      },
    },
    artSubjects: {
      type: Array,
      required: true,
    },
    deleteImageCallback: {
      type: Function,
      required: false,
    },
    styles: {
      type: Array,
      required: true,
    },
    editIllustration: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      imageUploading: false,
    };
  },
  mounted() {
    this.setupDropzone();
  },
  methods: {
    removeImage() {
      if (confirm('Are you sure you want to delete this image?')) {
        this.deleteImageCallback(this.image.id);
      }
    },
    toggleExpandArea() {
      $('.expand-area[data-id="' + this.image.file_id + '"]').slideToggle();
    },
    setupDropzone() {
      let self = this;
      let id = this.image.file_id + 'dropzone';

      Dropzone.options[id] = {
        paramName: 'image',
        createImageThumbnails: false,
        method: self.method,
        dictDefaultMessage: '',
        timeout: configs.dropzoneTimeout,
        params: {
          file_id: self.image.file_id,
          image_set_id: self.imageSet.id,
          image_set_image_id: self.image.id,
        },
        addedfile: function () {
          self.imageUploading = true;
        },
        error: function (f, data) {
          this.removeFile(f);

          self.imageUploading = false;

          let firstErrorKey = Object.keys(data.errors)[0],
            firstError = data.errors[firstErrorKey][0];    //Get first error

          toastr.error(firstError);
        },
        success: function (f, image) {
          this.removeFile(f);

          self.image.public_path = image.scaled100;

          setTimeout(() => {
            toastr.success('Replaced successfully');
          }, 1500);

          self.imageUploading = false;
        }
      };

      $("#" + id).dropzone({
        maxFiles: 1,
      });
    }
  },
  watch: {
    'image.art_subjects': function (value) {
      if (value.length <= 2) return;

      value.pop();

      toastr.error('Limit of subjects for image is 2');
    },
    'image.styles': function (value) {
      if (value.length <= 2) return;

      value.pop();

      toastr.error('Limit of styles for image is 2');
    },
  },
};
</script>